import {useCallback, useEffect, useMemo, useRef, useState} from "react"
import {useParams} from "react-router"
import {useHistory, useLocation} from 'react-router-dom'

import Title from '@base/Title'
import Toast from '@base/Toast'
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"

import {ProcessoResolver} from "@helpers/ProcessoHelper"

import EscolaService from "@services/EscolaService"
import DoneAllIcon from '@material-ui/icons/DoneAll';

function useQuery() {
  const {search} = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export const ListagemCartoesDuplicados = (props) => {
  const toastRef = useRef(null)
  const query = useQuery();
  const history = useHistory();


  const [, setNomeEscola] = useState("");

  const params = useParams();
  const processo = ProcessoResolver(params.processo);

  const location = useLocation();

  const carregarDados = useCallback(() => {
    EscolaService.listarPorCodigoInepOuEticket(processo.id, params.escola).then(escola => {
      setNomeEscola(escola.data.nome);
    });
  }, [processo.id, params.escola]);

  useEffect(() => carregarDados(), [carregarDados]);
  const [horaUltimoRefresh] = useState();

  function redirecionarParaPaginaDeConteudo(codigoObjetoPostal) {
    history.push(`/${processo.id}/objetosPostais/${codigoObjetoPostal}`);
  }

  function redirecionarParaPaginaDeTratamento(codigo) {
    history.push(`/${processo.id}/tratamentoCartoesDuplicados/${codigo}`);
  }


  const columns = [

    {label: 'Caixa', name: 'codigoCaixa', filter: 'objetoPostal.caixa.codigo', func: null, key: false},
    {
      label: 'Objeto Postal', name: 'numeroObjetoPostal', filter: 'objetoPostal', key: false, func: (c, l) => {
        if (l == null) {
          return "--"
        } else {
          return <span style={{cursor: 'pointer', textDecoration: 'underline'}}
                       onClick={() => redirecionarParaPaginaDeConteudo(c)}>{c}</span>;
        }
      }
    },
    {
      label: 'Tratamento', name: 'codigo', key: false, ordering: false, func: (c, l) => {
        if (l == null) {
          return "--"
        } else {
          return <DoneAllIcon color={'primary'} style={{cursor: 'pointer'}}
                              onClick={() => redirecionarParaPaginaDeTratamento(c)}/>;
        }
      }
    }
  ];

  return (
    <>
      <Toast ref={toastRef}/>
      <Title>Listagem de Cartões Duplicados</Title>
      <br/>

      <CartoesTableView refresh={horaUltimoRefresh} nivel={location.state !== undefined ? location.state.nivel : ""}
                        filtroObjetoPostal={query.get('objetosPostais') ? query.get('objetosPostais') : ""}
                        somenteComDuplicidadeNaoTratada={true}
                        processo={processo.id}
                        colunasAdicionais={columns}
                        exibeActions={false}
                        sessionStorage={"filtroTelaCartoesDuplicado"}
      />
    </>
  );
}

export default ListagemCartoesDuplicados;
